import React from 'react';
import { MdOutlineRadioButtonUnchecked } from 'react-icons/md';
import { MdOutlineRadioButtonChecked } from 'react-icons/md';

interface InputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'dangerouslySetInnerHTML'
  > {
  className?: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButton: React.FC<InputProps> = ({
  onChange,
  className,
  checked,
  ...rest
}: InputProps) => {
  return (
    <div>
      <input
        type="radio"
        id={rest.id}
        name={rest.name}
        value={rest.value}
        className="peer hidden"
        checked={checked}
        onChange={onChange}
        readOnly={rest.readOnly}
      />
      <label htmlFor={rest.id}>
        <div>
          {checked ? (
            <MdOutlineRadioButtonChecked
              fontSize={24}
              className="text-primary"
            />
          ) : (
            <MdOutlineRadioButtonUnchecked
              fontSize={24}
              className="text-shadow-3"
            />
          )}
        </div>
      </label>
    </div>
  );
};
